import Formsy from 'formsy-react';
import { Input, Checkbox, CheckboxGroup, ComponentMixin, Select } from 'formsy-react-components';
import FormRow from './FormRow';
import FormsySelect from './FormsySelect';
import Form from './Form';
import AdornedInput from './AdornedInput';
import SubmitButton from './SubmitButton';

Formsy.addValidationRule('isMoreThan', (values, value, minValue) =>
  Number(value) > Number(minValue)
);

Formsy.addValidationRule('isLessThan', (values, value, minValue) =>
  Number(value) < Number(minValue)
);

export {
  Form, Formsy, Input, FormRow, ComponentMixin, FormsySelect, AdornedInput, Select, SubmitButton, Checkbox, CheckboxGroup
};



// WEBPACK FOOTER //
// ./src/components/common/Forms/index.js